/**
 * Single source for the community name (F01-T07): used in the header, the
 * footer and the document title. The same literal is the pre-hydration
 * fallback <title> in index.html — keep the two in sync.
 */
export const SITE_NAME = "Communion de prière Notre-Dame du Mont-Carmel";
